<template>
    <div class="card">
        <div class="card-header" v-if="isSup">Update {{getSSSectionLabel}}(s)</div>
        <div class="card-header" v-if="!isSup">Update Establishment(s)</div>
        <div class="card-body" v-if="application">
            <div class="mb-2">
                Please note that changing your registered {{getSSSectionLabel}} will require affirmation from the new
                {{getSSSectionLabel}} to allow your license to remain active.
            </div>
            <div role="alert">
                <b-row>
                    <b-col>
                        <div class="text-danger" v-if="!$v.activeSupervisor.minLength
                    || !$v.activeSupervisor.required">
                            At least one valid current {{getSSSectionLabel}} is required.
                        </div>
                    </b-col>
                </b-row>
                <b-row>
                    <div class="text-danger" v-if="opts.minLengthError">
                        Cannot submit an amendment request with no changes.
                    </div>
                </b-row>
            </div>

            <div v-for="(sup, index) in activeSupervisor" :key="sup.id">
                <b-row v-if="isGuestApp">
                    <b-col>
                        <BaseTextOutput label="Work Dates" :value="sup.workDate.startDate + ' thru ' + sup.workDate.endDate"/>
                    </b-col>
                </b-row>
                <b-row v-if="!isSup">
                    <b-col>
                        <BaseTextOutput :label="getSSSectionLabel" :value="sup.formattedAffirmation"/>
                    </b-col>
                </b-row>
                <b-row v-if="isSup">
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="sup.licenseNbr"
                                       :v="$v.activeSupervisor.$each[index].licenseNbr"
                                       slug="licenseNbr"
                                       :label="getSSLicenseLabel"
                                       :key="index"
                                       :setId="'supLicNbr'+index"
                                       @input="setName(sup.licenseNbr, index)"
                                       :plaintext="(sup.id !== null && sup.id !== undefined)"
                        />
                    </b-col>
                    <b-col cols="12" lg="4">
                        <BaseTextInput v-model="sup.name"
                                       :v="$v.activeSupervisor.$each[index].name"
                                       slug="name"
                                       :label="getSSNameLabel"
                                       :key="index"
                                       :setId="'supName'+index"
                                       :plaintext="true"
                        />
                    </b-col>
                    <b-col cols="2" class="d-flex align-items-center" v-if="sup.id != null && (!isGuestApp || !isPastStartDate(sup.workDate.startDate))">
                        <button class="btn btn-warning" @click="showChangeModal(sup, index)">
                            Update {{getSSSectionLabel}}
                        </button>
                    </b-col>
                    <b-col cols="2" class="d-flex align-items-center">
                        <button class="btn btn-secondary" @click="(sup.id == null && sup.updatedId == null)
                            ? terminateSupervisor(index) : showTerminateModal(sup, index)">
                            Terminate {{getSSSectionLabel}}
                        </button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="3">
                        <BaseTextInput v-model="sup.establishment.supervisedEstName"
                                       :v="$v.activeSupervisor.$each[index].establishment.supervisedEstName"
                                       slug="supervisedEstName"
                                       label="Establishment Name"
                                       setId="supervisedEstName"
                                       :plaintext="(sup.id !== null && sup.id !== undefined)"
                        />
                    </b-col>
                    <b-col cols="3">
                        <BaseMaskedTextInput v-model="sup.establishment.supervisedEstPhoneNumber"
                                             :v="$v.activeSupervisor.$each[index].establishment.supervisedEstPhoneNumber"
                                             slug="supervisedEstPhoneNumber"
                                             label="Establishment Phone Number"
                                             setId="supervisedEstPhoneNumber"
                                             mask="(###)###-####"
                                             :plaintext="(sup.id !== null && sup.id !== undefined)"
                        />
                    </b-col>
                    <b-col cols="4">
                        <BaseTextInput v-model="sup.establishment.supervisedEstWebsite"
                                       :v="$v.activeSupervisor.$each[index].establishment.supervisedEstWebsite"
                                       slug="supervisedEstWebsite"
                                       label="Establishment Website"
                                       setId="supervisedEstWebsite"
                                       :plaintext="(sup.id !== null && sup.id !== undefined)"
                        />
                    </b-col>
                    <b-col cols="2" class="d-flex align-items-center" v-if="!isSup && sup.id != null && (!isGuestApp || !isPastStartDate(sup.workDate.startDate))">
                        <button class="btn btn-warning" @click="showEstChangeModal(sup, index)">
                            Update Establishment
                        </button>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12">
                        <BaseTextInput v-model="sup.establishment.supervisedEstFullAddress"
                                       :v="$v.activeSupervisor.$each[index].establishment.supervisedEstFullAddress"
                                       slug="supervisedEstFullAddress"
                                       label="Establishment Address"
                                       tip="Please include street address, city, state, postal code, and country"
                                       setId="supervisedEstFullAddress"
                                       :plaintext="(sup.id !== null && sup.id !== undefined)"
                        />
                    </b-col>
                </b-row>
                <b-row v-for="(hrs, idx) in sup.establishment.establishmentHours" :key="hrs.id">
                    <b-col cols="6">
                        <form-group label="Establishment Days" :validator="$v.activeSupervisor.$each[index].establishment.establishmentHours.$each[idx].days">
                            <b-form-checkbox-group
                                    :id="'days'+index+'-'+idx"
                                    v-model="hrs.days"
                                    :options="opts.dayTypeOptions"
                                    :disabled="sup.id != null"
                            ></b-form-checkbox-group>
                        </form-group>
                    </b-col>
                    <b-col cols="4">
                        <BaseTextInput v-model="hrs.hours"
                                       :v="$v.activeSupervisor.$each[index].establishment.establishmentHours.$each[idx].hours"
                                       slug="name"
                                       label="Hours"
                                       :key="idx"
                                       :setId="'hours'+index+'-'+idx"
                                       :plaintext="sup.id != null"
                        />
                    </b-col>

                    <b-col cols="2" class="d-flex align-items-center" v-if="sup.id == null">
                        <button class="btn btn-secondary" @click="removeEstHours(index, idx)">
                            Remove Hours
                        </button>
                    </b-col>
                </b-row>
                <b-row v-if="sup.id == null">
                    <b-col>
                        <button class="btn btn-secondary" @click="addEstHours(index)">
                            Add Additional Hours
                        </button>
                    </b-col>
                </b-row>
            </div>
            <b-row v-if="!isGuestApp && isSup" class="mt-3">
                <b-col cols="2">
                    <button class="btn btn-secondary" @click="addSupervisor">
                        Add New {{getSSSectionLabel}}
                    </button>
                </b-col>
            </b-row>
            <b-row class="mt-2" v-if="isSup">
                <b-col>
                    <p style="font-weight:750;" class="mb-1">Terminated or Updated {{getSSSectionLabel}}s</p>
                    <b-table hover small show-empty class="sr-caption"
                             aria-live="polite"
                             responsive="true"
                             :fields="opts.fields"
                             :items="opts.terminatedSupervisor"
                             :busy="false"
                             label-sort-asc=""
                             label-sort-desc=""
                             caption="Terminated or Updated Supervisor table.  To sort the data in this table by a specific column,
                                go to the appropriate column header cell and use enter to sort the data ascending.
                                Use enter again to sort descending.">
                        <template v-slot:no-data>
                            No {{getSSSectionLabel}}s Found.
                        </template>
                        <div slot="table-busy" class="text-center text-danger my-2">
                            <b-spinner class="align-middle" label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                        <template slot="empty" slot-scope="scope">
                            No {{getSSSectionLabel}}s Found.
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </div>

        <b-modal id="terminate-modal" hide-header hide-footer>
            <div v-if="!!opts.selected">
                <h2>Terminate {{getSSSectionLabel}}</h2>
                <hr/>
                <form ref="form" @submit.prevent="terminateSupervisor(opts.selected.index)">
                    You are about to terminate the {{getSSSectionLabel}} <span v-if="isGuestApp">for the work date(s)
                    {{opts.selected.workDate.startDate}} - {{opts.selected.workDate.endDate}},</span>
                    at establishment {{opts.selected.establishment.supervisedEstName}}.
                    <p class="text-danger" v-if="isGuestApp">
                        If you terminate this sponsor, you will also remove the work dates
                        {{opts.selected.workDate.startDate}} - {{opts.selected.workDate.endDate}} from your application.
                        If you need to update the sponsor for these dates, please use the "Update Sponsor" option instead.
                    </p>
                    Please provide the reason for this removal.
                    <BaseParagraphInput v-model="opts.reason"
                                        :v="$v.opts.reason"
                                        slug="reason"
                                        label="Removal Reason"
                                        setId="terminate-modal-id"/>
                    <p class="mt-2">Press Confirm to terminate or Cancel to return to your application.</p>
                    <div>
                        <b-button @click="closeTerminateModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary">Confirm</b-button>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal id="change-modal" hide-header hide-footer>
            <div v-if="!!opts.selected">
                <h2>Update {{getSSSectionLabel}}</h2>
                <hr/>
                <form ref="form" @submit.prevent="updateSupervisor(opts.selected.index)">
                    You are about to update the {{getSSSectionLabel}} <span v-if="isGuestApp">for work date(s)
                    {{opts.selected.workDate.startDate}} - {{opts.selected.workDate.endDate}},</span>
                    at establishment {{opts.selected.establishment.supervisedEstName}}.
                    Please provide the reason for this change.
                    <BaseParagraphInput v-model="opts.reason"
                                        :v="$v.opts.reason"
                                        slug="reason"
                                        label="Update Reason"
                                        setId="change-modal-id"/>
                    <p class="mt-2">Press Confirm to remove or Cancel to return to your dashboard.</p>
                    <div>
                        <b-button @click="closeChangeModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary">Confirm</b-button>
                    </div>
                </form>
            </div>
        </b-modal>
        <b-modal id="est-change-modal" hide-header hide-footer>
            <div v-if="!!opts.selected">
                <h2>Update Establishment</h2>
                <hr/>
                <form ref="form" @submit.prevent="updateSupervisor(opts.selected.index)">
                    You are about to update the establishment <span v-if="isGuestApp">for work date(s)
                    {{opts.selected.workDate.startDate}} - {{opts.selected.workDate.endDate}},</span>
                    with {{getSSSectionLabel}} {{opts.selected.name}}.
                    Please provide the reason for this change.
                    <BaseParagraphInput v-model="opts.reason"
                                        :v="$v.opts.reason"
                                        slug="reason"
                                        label="Update Reason"
                                        setId="change-modal-id"/>
                    <p class="mt-2">Press Confirm to remove or Cancel to return to your dashboard.</p>
                    <div>
                        <b-button @click="closeEstChangeModal" style="margin-right:15px;" variant="secondary">Cancel</b-button>
                        <b-button type="submit" variant="primary">Confirm</b-button>
                    </div>
                </form>
            </div>
        </b-modal>
    </div>

</template>
<script>
    import BaseTextInput from '@/components/templates/input/BaseTextInput.vue'
    import license from '@/validators/license'
    import { required, requiredIf, minLength, maxLength } from 'vuelidate/lib/validators'
    import axiosRetry from 'axios-retry'
    import axios from "axios"
    import moment from 'moment'

    export default {
        props: {
            application: {
                type: Object,
                default () {
                    return {
                        mnSupervisor: [{
                            id: null,
                            name: null,
                            licenseNbr: null,
                            workDate: {
                                id: null,
                                startDate: '',
                                endDate: '',
                            },
                            establishment: {
                                establishmentId: null,
                                supervisedEstName: null,
                                supervisedEstFullAddress: null,
                                supervisedEstWebsite: null,
                                supervisedEstPhoneNumber: null,
                                establishmentHours: [{
                                    id: null,
                                    hours: null,
                                    days: []
                                }],
                            }
                        }],
                    }
                }
            },
            isSup: Boolean
        },

        data: () => {
            return {
                activeSupervisor: [],
                opts: {
                    fields: [
                        {key: 'name', sortable: true, label: 'Name'},
                        {key: 'licenseNbr', sortable: true, label: 'License Number'},
                        {key: 'terminatedDate', sortable: true, label: 'Date Terminated'},
                        {key: 'changeDate', sortable: true, label: 'Date Updated'},
                    ],
                    dayTypeOptions: [],
                    reason: null,
                    selected: null,
                    terminatedSupervisor: [],
                    newSups: [],
                    minLengthError: false
                }

            }
        },
        components: {
            BaseTextInput
        },
        computed: {
            isGuestApp() {
                return this.application && this.application.subCategory === 'GUEST'
            },
            getSSLicenseLabel() {
                if (this.application.subCategory == 'GUEST') {
                    return "Sponsor's Minnesota license number"
                } else {
                    return "Supervisor's Minnesota license number"
                }
            },
            getSSNameLabel() {
                if (this.application.subCategory == 'GUEST') {
                    return "Name of Minnesota licensed Sponsor"
                } else {
                    return "Name of Minnesota licensed Supervisor"
                }
            },
            getSSSectionLabel() {
                if (this.application.subCategory == 'GUEST') {
                    return "Sponsor"
                } else {
                    return "Supervisor"
                }
            },
        },
        validations() {
            return {
                activeSupervisor: {
                    required,
                    minLength: minLength(1),
                    $each: {
                        name: {
                            required
                        },
                        licenseNbr: {
                            required,
                            minLength: minLength(6),
                            maxLength: maxLength(6),
                            license: this.isSup ? license(this.application.license ? this.application.license.licenseType : null) : true
                        },
                        establishment: {
                            supervisedEstName: {required},
                            supervisedEstFullAddress: {required},
                            supervisedEstWebsite: {required: false, maxLength: maxLength(75)},
                            supervisedEstPhoneNumber: {required, minLength: minLength(13)},
                            establishmentHours: {
                                required,
                                $each: {
                                    hours: {
                                        required: requiredIf((object) => {
                                            return !object.days.every(d => d === 'APT')
                                        })
                                    },
                                    days: {
                                        required,
                                        minLength: minLength(1)
                                    }
                                }
                            },
                        },
                    }
                },
                opts: {
                    reason: { required },
                },
                form: [ 'activeSupervisor' ],
                reasonForm: [ 'opts.reason']
            }
        },
        methods: {
            showTerminateModal(item, index) {
                this.$bvModal.show('terminate-modal')
                this.opts.selected = item
                this.opts.selected.index = index
            },
            closeTerminateModal() {
                this.opts.selected = null
                this.opts.reason = null
                this.$bvModal.hide('terminate-modal')
            },
            showChangeModal(item, index) {
                this.$bvModal.show('change-modal')
                this.opts.selected = item
                this.opts.selected.index = index
            },
            closeChangeModal() {
                this.opts.selected = null
                this.opts.reason = null
                this.$bvModal.hide('change-modal')
            },
            showEstChangeModal(item, index) {
                this.$bvModal.show('est-change-modal')
                this.opts.selected = item
                this.opts.selected.index = index
            },
            closeEstChangeModal() {
                this.opts.selected = null
                this.opts.reason = null
                this.$bvModal.hide('est-change-modal')
            },

            addSupervisor: function () {
                this.activeSupervisor.push({
                    id: null,
                    name: null,
                    licenseNbr: null,
                    workDate: null,
                    establishment: {
                        establishmentId: null,
                        supervisedEstName: null,
                        supervisedEstFullAddress: null,
                        supervisedEstWebsite: null,
                        supervisedEstPhoneNumber: null,
                        establishmentHours: [{
                            id: null,
                            hours: null,
                            days: []
                        }],
                    }
                });
            },
            updateSupervisor: function (i) {
                this.$v.reasonForm.$touch()
                if (!this.$v.reasonForm.$invalid) {
                    var pd = JSON.parse(JSON.stringify(this.activeSupervisor[i]))
                    pd.changeDate =  moment().format('YYYY-MM-DD')
                    pd.changeReason = this.opts.reason
                    this.resetReason()
                    this.application.prevMnSupervisor.push(pd)
                    var change = JSON.parse(JSON.stringify(this.activeSupervisor[i]))
                    this.activeSupervisor[i] = {
                        id: null,
                        name: change.name,
                        licenseNbr: change.licenseNbr,
                        establishment: change.establishment,
                        workDate: change.workDate,
                        updatedId: change.id
                    }
                    this.activeSupervisor.splice()
                    this.closeChangeModal()
                    this.closeEstChangeModal()
                }
            },
            terminateSupervisor: function (i) {
                if (this.activeSupervisor[i].id == null && !this.activeSupervisor[i].updatedId) {
                    this.$delete(this.activeSupervisor, i)
                } else {
                    this.$v.reasonForm.$touch()
                    if (!this.$v.reasonForm.$invalid) {
                        if (this.activeSupervisor[i].id == null) {
                            var filter = this.application.prevMnSupervisor.filter(sup => sup.id === this.application.mnSupervisor[i].updatedId)
                            if (filter.length > 0) {
                                var old = filter[0]
                                old.changeDate = null
                                old.changeReason = null
                                old.terminatedDate =  moment().format('YYYY-MM-DD')
                                old.terminatedReason = this.opts.reason
                            }
                            this.resetReason()
                            this.$delete(this.activeSupervisor, i)
                            this.closeTerminateModal()
                        } else {
                            var pd = JSON.parse(JSON.stringify(this.activeSupervisor[i]))
                            pd.terminatedDate =  moment().format('YYYY-MM-DD')
                            pd.terminatedReason = this.opts.reason
                            pd.updatedId = pd.id
                            this.resetReason()
                            this.application.prevMnSupervisor.push(pd)
                            this.$delete(this.activeSupervisor, i)
                            this.closeTerminateModal()
                        }
                    }
                }
            },
            addEstHours: function (i) {
                if(this.activeSupervisor[i].establishment.establishmentHours === null) {
                    this.activeSupervisor[i].establishment.establishmentHours = []
                }
                this.activeSupervisor[i].establishment.establishmentHours.push({
                    id: null,
                    hours: null,
                    days: []
                })
                this.activeSupervisor.splice()
            },
            removeEstHours: function (i, i2) {
                this.$delete(this.activeSupervisor[i].establishment.establishmentHours,i2)
                this.activeSupervisor.splice()
            },
            validate() {
                this.application.mnSupervisor = this.activeSupervisor
                this.opts.newSups = this.activeSupervisor.filter(w => w.id == null)
                var isValid
                if (this.opts.newSups.length === 0 && this.application.prevMnSupervisor.filter(s => s.updatedId != null).length === 0) {
                    isValid = false
                    this.opts.minLengthError = true
                } else {
                    this.$v.form.$touch()
                    isValid = !this.$v.form.$invalid
                }
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },
            showRootToast(title, message, type) {
                this.$root.$bvToast.toast(message, {
                    title: title,
                    toaster: 'b-toaster-top-center',
                    solid: true,
                    variant: type,
                    appendToast: true,
                    noAutoHide:true
                })
                this.toastFocus()
            },
            toastFocus() {
                setTimeout(() => {
                    let elem = document.getElementsByClassName("toast")
                    elem = elem[elem.length-1]
                    elem.focus()
                }, 100)
            },
            setName(licenseNbr, index) {
                if (licenseNbr && licenseNbr.length === 6) {
                    let payload = {
                        number: licenseNbr,
                        licenseType: this.application.license.licenseType
                    }
                    axios.post(`${process.env.VUE_APP_API_BASE_URL}/license/validate/license`, payload)
                        .then(response => {
                            if (response.data.status) {
                                this.activeSupervisor[index].name = response.data.fullName
                            } else {
                                this.activeSupervisor[index].name = null
                            }
                            this.activeSupervisor.splice()
                        })
                } else {
                    this.activeSupervisor[index].name = null
                    this.activeSupervisor.splice()
                }
            },
            updateActive() {
                this.activeSupervisor = this.application.mnSupervisor.filter(s => s.terminatedDate === null)
                this.opts.terminatedSupervisor = this.application.prevMnSupervisor.filter(s => s.terminatedDate !== null || s.changeDate != null)
            },
            isPastStartDate(start) {
                return moment(start).isBefore(moment())
            },
            resetReason() {
                this.opts.reason = null
            },
            loadDayTypes() {
                axios.get(`${process.env.VUE_APP_API_BASE_URL}/application/public/dayTypes`, { ignoreHeader: true })
                    .then(response => {
                        for (let type of response.data) {
                            this.opts.dayTypeOptions.push({
                                value: type.code,
                                text: type.description
                            })
                        }
                    })
            },
        },
        mounted () {
            this.updateActive()
            this.loadDayTypes()
        },
        watch: {
            application() {
                for (var prop in this.application) {
                    if (this.hasOwnProperty(prop) && this.application[prop] != null) {
                        this[prop] = this.application[prop];
                    }
                }
                if (this.application.mnSupervisor) {
                    this.application.mnSupervisor.forEach((sup, idx) => {
                        if(sup.workDate === null && this.isGuestApp) {
                            sup.workDate = {
                                id: null,
                                startDate: '',
                                endDate: '',
                            }
                        }
                        if (sup.establishment.establishmentHours === null ) {
                            sup.establishment.establishmentHours =
                                [{
                                    id: null,
                                    hours: null,
                                    days: []
                                }]
                        }
                        sup.establishment.establishmentHours.forEach(e => {
                            if (e.days === null) {
                                e.days = []
                            }
                        })
                    })
                }
                this.updateActive()
            }
        },
    }
</script>
